import { render, staticRenderFns } from "./ParagraphOne.vue?vue&type=template&id=5edaa754&scoped=true&"
import script from "./ParagraphOne.vue?vue&type=script&lang=js&"
export * from "./ParagraphOne.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphOne.vue?vue&type=style&index=0&id=5edaa754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edaa754",
  null
  
)

export default component.exports